document.addEventListener("DOMContentLoaded", function() {
    const faqItems = document.querySelectorAll(".faq-item");

    faqItems.forEach((item) => {
        const titleWrap = item.querySelector(".faq-title-wrap");
        const contentWrap = item.querySelector(".faq-content-wrap");
        const arrow = item.querySelector(".faq-title-wrap span");

        //= Only proceed if the required elements are found
        if (titleWrap && contentWrap && arrow) {
            titleWrap.addEventListener("click", function() {
                //= Collapse all items except the clicked one
                faqItems.forEach((otherItem) => {
                    const otherContentWrap = otherItem.querySelector(".faq-content-wrap");
                    const otherArrow = otherItem.querySelector(".faq-title-wrap span");

                    if (otherContentWrap && otherArrow && otherItem !== item) {
                        otherContentWrap.classList.remove("show");
                        otherArrow.classList.remove("show");
                    }
                });

                //= Toggle the clicked item
                contentWrap.classList.toggle("show");
                arrow.classList.toggle("show");
            });
        }
    });

    // Show/hide FAQ sections in DOM and CSS based on screen size
    let faqDesktop = document.querySelector(".faq-desktop");
    let faqMobile = document.querySelector(".faq-mobile");
    let desktopParent = faqDesktop ? faqDesktop.parentNode : null;
    let mobileParent = faqMobile ? faqMobile.parentNode : null;

    function showAndHideFaqSections() {
        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            // Show mobile, remove desktop from DOM
            if (faqDesktop) {
                if (faqDesktop.parentNode) {
                    faqDesktop.remove();
                }
            }
            if (faqMobile) {
                if (!faqMobile.parentNode && mobileParent) {
                    mobileParent.appendChild(faqMobile);
                }
                // Override CSS to show mobile
                faqMobile.style.display = "block";
            }
        } else {
            // Show desktop, remove mobile from DOM
            if (faqMobile) {
                if (faqMobile.parentNode) {
                    faqMobile.remove();
                }
            }
            if (faqDesktop) {
                if (!faqDesktop.parentNode && desktopParent) {
                    desktopParent.appendChild(faqDesktop);
                }
                // Override CSS to show desktop
                faqDesktop.style.display = "block";
            }
        }
    }

    // Run on page load
    showAndHideFaqSections();

    // Run on window resize with debounce
    let resizeTimer;
    window.addEventListener("resize", function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(showAndHideFaqSections, 150);
    });
});